
import { BucketIcon } from '../../aws';

import { fmtS3ConsoleLink } from '../../utils/formatters';

export function fmtDataConfigurationRefs(value) {
  const values=Array.isArray(value)?value:[value];
  return values.map((d) => {
    const ref={
      id: d.ResourceId,
      description: d.Description,
    };
    if(d.Location) {
      const location=(d.Location === 'string')?JSON.parse(d.Location):d.Location;
      if(location.S3Uri) {
        ref.extLink={
          href: fmtS3ConsoleLink(location.S3Uri),
          icon: BucketIcon,
          iconProps: {
            titleAccess: "View in S3..."
          }
        };
      }
    }
    if(d.CatalogConfiguration && d.CatalogConfiguration.DatabaseName && d.CatalogConfiguration.DatabaseName!=='unspecified') {
      ref.name=d.CatalogConfiguration.DatabaseName;
    } else {
      ref.name=ref.id;
    }
    return ref;
  });
}
